export default [
	{
		path: "/contractorlogo",
		name: "contractorlogo",
		component: () => import(/* webpackChunkName: "contractor" */ "@/views/contractorAdmin/vLogo.vue"),
		meta: { title: "Logo", auth: true, roles: ["retailerAdmin"] },
	},
	{
		path: "/contractorbannerads",
		name: "contractorbannerads",
		component: () => import(/* webpackChunkName: "contractor" */ "@/views/contractorAdmin/vBannerAds.vue"),
		meta: { title: "Banner Ads", auth: true, roles: ["retailerAdmin"] },
	},
	{
		path: "/contractorsplashpage",
		name: "contractorsplashpage",
		component: () => import(/* webpackChunkName: "contractor" */ "@/views/contractorAdmin/vSplashPage.vue"),
		meta: { title: "Manage Splash Pages", auth: true, roles: ["retailerAdmin"] },
	},
	{
		path: "/contractorhomepage",
		name: "contractorhomepage",
		component: () => import(/* webpackChunkName: "contractor" */ "@/views/contractorAdmin/vHomePageCard.vue"),
		meta: { title: "Manage Home Page Cards", auth: true, roles: ["retailerAdmin"] },
	},
	{
		path: "/helpedit/:id?",
		name: "helpedit",
		component: () => import(/* webpackChunkName: "misc" */ "@/views/contractorAdmin/vHelpEdit.vue"),
		meta: { title: "Help Edit", auth: true, roles: ["globalAdmin"] },
	},
	{
		path: "/helpedit/:name?",
		name: "helpedit",
		component: () => import(/* webpackChunkName: "misc" */ "@/views/contractorAdmin/vHelpEdit.vue"),
		meta: { title: "Help Edit", auth: true, roles: ["globalAdmin"] },
	},
];
